import { Badge, Button } from '@fluentui/react-components';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

// component functions
import * as ComponentFunctions from './StageItemBadge.Functions';

// styles
import './StageItemBadge.Styles.css';
import { Group20Regular } from '@fluentui/react-icons';

export const StageItemBadgeComponent = (props: ComponentFunctions.Props) => {
    const [t] = useTranslation();

    // if (!props.StageItems || props.StageItems.length === 0) {
    //     return null;
    // }

    return (
        <span className="StageItemBadgeContainer">
            {props.StageItems.map((stageItem, index) => (
                <Badge
                    key={`${stageItem.id ?? 'stage-item'}-${index}`}
                    appearance="tint"
                    color='informative'
                    title={`${t('stageItemBadge.props.associatedVisit')}: ${stageItem.emrProtocolVisitName}`}
                >
                    {stageItem.emrProtocolVisitName}
                </Badge>
            
            ))}
        </span>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageItemBadgeComponent as any);
